var _style, _path, _path2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardsIconCashCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#C27515;}\n\t.st2{fill:url(#SVGID_00000017485907807076281030000000746510323772439202_);}\n\t.st3{opacity:0.2;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:url(#SVGID_00000132049342537661352240000016565717284578582151_);}\n\t.st6{opacity:0.2;fill:url(#SVGID_00000057129872733613856880000017723726450408766385_);}\n\t.st7{fill:url(#SVGID_00000040573119195983456040000002329966410197691829_);}\n\t.st8{opacity:0;fill:none;stroke:#FFFFFF;stroke-width:0.1;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.7981,
    y1: 8.9808,
    x2: 41.2009,
    y2: 41.3835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB50A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEA30D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,47.7c-1.9,0-3.9-0.5-5.5-1.6l0,0l0,0c-1.7,1-3.6,1.6-5.5,1.6c-1.6,0-3.1-0.3-4.5-1 c-2.5-1.2-4.4-3.3-5.4-6c-0.3-0.7-0.4-1.5-0.5-2.3c-1.1-0.4-2.1-0.9-3-1.7c-1.9-1.5-3.2-3.6-3.7-5.9c-0.6-2.7-0.1-5.5,1.3-7.9 c0.4-0.7,0.9-1.3,1.4-1.8c-0.3-0.7-0.4-1.5-0.5-2.3c-0.3-2.8,0.5-5.5,2.2-7.7c2-2.5,5-4,8.2-4c0.4,0,0.8,0,1.1,0.1 C18,4.1,21.4,2.3,25,2.3c3.6,0,7,1.8,8.9,4.9c0.4,0,0.8-0.1,1.1-0.1c3.2,0,6.2,1.4,8.2,4c1.7,2.2,2.5,4.9,2.2,7.7 c-0.1,0.8-0.3,1.5-0.5,2.3c0.5,0.5,1,1.2,1.4,1.8c1.5,2.4,2,5.2,1.3,7.9c-0.5,2.3-1.9,4.4-3.7,5.9c-0.9,0.7-1.9,1.3-3,1.7 c-0.1,0.8-0.3,1.5-0.5,2.3c-0.9,2.6-2.8,4.8-5.4,6C33.7,47.3,32.1,47.7,30.6,47.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,2.5c3.6,0,6.9,1.9,8.8,4.9c0.4,0,0.8-0.1,1.2-0.1c3.2,0,6.1,1.4,8.1,3.9c1.7,2.2,2.5,4.9,2.2,7.6 c-0.1,0.8-0.3,1.6-0.5,2.3c0.6,0.6,1.1,1.2,1.5,1.9c1.5,2.3,1.9,5.1,1.3,7.8c-0.5,2.3-1.8,4.4-3.7,5.8c-0.9,0.7-1.9,1.3-3.1,1.7 c-0.1,0.8-0.3,1.6-0.5,2.3c-0.9,2.6-2.8,4.7-5.3,5.9c-1.4,0.7-2.9,1-4.5,1c-1.9,0-3.8-0.5-5.4-1.5c0,0-0.1,0-0.1-0.1 c0,0-0.1,0-0.1,0.1c-1.6,1-3.5,1.5-5.4,1.5c-1.6,0-3.1-0.3-4.5-1c-2.5-1.2-4.4-3.3-5.3-5.9c-0.3-0.8-0.4-1.5-0.5-2.3 c-1.1-0.4-2.1-0.9-3-1.7c-1.9-1.5-3.2-3.5-3.7-5.8c-0.6-2.7-0.1-5.5,1.3-7.8c0.4-0.7,0.9-1.3,1.5-1.9c-0.3-0.7-0.4-1.5-0.5-2.3 c-0.3-2.7,0.5-5.4,2.2-7.6c2-2.5,4.9-3.9,8.1-3.9c0.4,0,0.8,0,1.2,0.1C18.1,4.3,21.4,2.5,25,2.5 M25,2.2c-3.7,0-7,1.8-9,4.9 C15.7,7,15.3,7,15,7c-3.3,0-6.3,1.5-8.3,4c-1.8,2.2-2.6,5-2.2,7.8c0.1,0.8,0.2,1.5,0.5,2.2c-0.5,0.5-1,1.1-1.4,1.8 c-1.5,2.4-2,5.3-1.4,8c0.5,2.4,1.9,4.5,3.8,6c0.9,0.7,1.9,1.3,3,1.6C9,39.2,9.2,40,9.4,40.7c0.9,2.7,2.9,4.8,5.4,6.1 c1.5,0.7,3,1.1,4.6,1.1c2,0,3.9-0.5,5.6-1.6c1.7,1,3.6,1.6,5.6,1.6c1.6,0,3.2-0.4,4.6-1.1c2.6-1.2,4.5-3.4,5.4-6.1 c0.3-0.7,0.4-1.5,0.5-2.2c1.1-0.4,2.1-0.9,3-1.6c1.9-1.5,3.2-3.6,3.8-6c0.6-2.8,0.2-5.6-1.4-8c-0.4-0.6-0.9-1.2-1.4-1.8 c0.2-0.7,0.4-1.4,0.5-2.2c0.3-2.8-0.5-5.6-2.2-7.8c-2-2.6-5.1-4-8.3-4c-0.4,0-0.7,0-1.1,0.1C32,4,28.7,2.2,25,2.2L25,2.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178176440363416125930000010697357448387388835_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.3813,
    y1: 6.5631,
    x2: 45.6923,
    y2: 45.8742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDE4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE766"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178176440363416125930000010697357448387388835_)"
    },
    d: "M30.6,45c-1.5,0-2.9-0.4-4.1-1.2 c-0.5-0.3-1-0.7-1.4-1.1c-0.4,0.4-0.9,0.8-1.4,1.1c-1.2,0.8-2.7,1.2-4.1,1.2c-1.2,0-2.3-0.3-3.4-0.8c-1.9-0.9-3.3-2.5-4-4.5 c-0.4-1.1-0.5-2.3-0.4-3.5c-1.5-0.2-2.9-0.7-4-1.6c-1.4-1.1-2.4-2.7-2.8-4.4c-0.5-2-0.1-4.1,1-5.9c0.6-1,1.5-1.9,2.5-2.5 c-0.6-1-1-2.1-1.2-3.3c-0.2-2.1,0.3-4.1,1.6-5.8c1.5-1.9,3.7-3,6.1-3c0.9,0,1.8,0.2,2.6,0.5C18.7,7.2,21.6,5,25,5 c3.4,0,6.3,2.2,7.4,5.3c0.8-0.3,1.7-0.5,2.6-0.5c2.4,0,4.6,1.1,6.1,3c1.3,1.6,1.9,3.7,1.7,5.8c-0.1,1.2-0.5,2.3-1.2,3.3 c1,0.6,1.8,1.5,2.5,2.5c1.1,1.8,1.5,3.9,1,5.9c-0.4,1.7-1.4,3.3-2.8,4.4c-1.2,0.9-2.6,1.5-4,1.6c0.1,1.2,0,2.4-0.4,3.5 c-0.7,2-2.1,3.6-4,4.5C32.9,44.7,31.7,45,30.6,45z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.6,45c-1.5,0-2.9-0.4-4.1-1.2c-0.5-0.3-1-0.7-1.4-1.1c-0.4,0.4-0.9,0.8-1.4,1.1 c-1.2,0.8-2.7,1.2-4.1,1.2c-1.2,0-2.3-0.3-3.4-0.8c-1.9-0.9-3.3-2.5-4-4.5c-0.4-1.1-0.5-2.3-0.4-3.5c-1.5-0.2-2.9-0.7-4-1.6 c-1.4-1.1-2.4-2.7-2.8-4.4c-0.5-2-0.1-4.1,1-5.9c0.6-1,1.5-1.9,2.5-2.5c-0.6-1-1-2.1-1.2-3.3c-0.2-2.1,0.3-4.1,1.6-5.8 c1.5-1.9,3.7-3,6.1-3c0.9,0,1.8,0.2,2.6,0.5C18.7,7.2,21.6,5,25,5c3.4,0,6.3,2.2,7.4,5.3c0.8-0.3,1.7-0.5,2.6-0.5 c2.4,0,4.6,1.1,6.1,3c1.3,1.6,1.9,3.7,1.7,5.8c-0.1,1.2-0.5,2.3-1.2,3.3c1,0.6,1.8,1.5,2.5,2.5c1.1,1.8,1.5,3.9,1,5.9 c-0.4,1.7-1.4,3.3-2.8,4.4c-1.2,0.9-2.6,1.5-4,1.6c0.1,1.2,0,2.4-0.4,3.5c-0.7,2-2.1,3.6-4,4.5C32.9,44.7,31.7,45,30.6,45z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183222233652590390420000000782735724850683013_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.5603,
    y1: 9.2638,
    x2: 32.1748,
    y2: 34.249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183222233652590390420000000782735724850683013_)"
    },
    d: "M41.2,16.1c0.3-1.7-0.5-2.3-0.8-2.7 c-1.3-1.7-3.3-2.6-5.4-2.6c-0.8,0-1.6,0.1-2.3,0.4l-0.9,0.3l-0.3-0.9c-0.9-2.8-3.6-4.7-6.5-4.7c-3,0-5.6,1.9-6.5,4.7l-0.3,0.9 l-0.9-0.3c-0.7-0.3-1.5-0.4-2.3-0.4c-2.1,0-4.1,0.9-5.4,2.6c-1.1,1.4-1.7,3.2-1.5,5.1c0.1,1.1,0.5,2,1,2.9l0.5,0.8l-0.8,0.5 c-0.9,0.6-1.6,1.3-2.2,2.2c-0.5,0.8-0.9,1.6-1,2.5C5.3,32.5,38.1,33.2,41.2,16.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000010309141209388680800000011487968328444456071_",
    cx: 14.2476,
    cy: 10.7712,
    r: 17.1381,
    gradientTransform: "matrix(0.7946 -0.6071 0.364 0.4764 -0.9942 14.2901)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000010309141209388680800000011487968328444456071_)"
    },
    d: "M42.8,18.5 c0.2-2.1-0.3-4.1-1.7-5.8c-1.5-1.9-3.7-3-6.1-3c-0.9,0-1.8,0.2-2.6,0.5C31.3,7.2,28.4,5,25,5c-3.4,0-6.3,2.2-7.4,5.3 C16.8,10,15.9,9.8,15,9.8c-2.4,0-4.6,1.1-6.1,3c-1.3,1.6-1.9,3.7-1.6,5.8c0.1,1.2,0.5,2.3,1.2,3.3c-1,0.6-1.8,1.5-2.5,2.5 c-1.1,1.8-1.5,3.9-1,5.9l-2.5,0.6c-0.6-2.7-0.1-5.5,1.3-7.8c0.4-0.7,0.9-1.3,1.5-1.9c-0.3-0.7-0.4-1.5-0.5-2.3 c-0.3-2.7,0.5-5.4,2.2-7.6c2-2.5,4.9-3.9,8.1-3.9c0.4,0,0.8,0,1.2,0.1c1.9-3,5.2-4.9,8.8-4.9c3.6,0,6.9,1.9,8.8,4.9 c0.4,0,0.8-0.1,1.2-0.1c3.2,0,6.1,1.4,8.1,3.9c1.3,1.7,2.1,3.7,2.2,5.7L42.8,18.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123422869104479054930000005616216476619262395_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.8377,
    y1: 16.102,
    x2: 31.9105,
    y2: 37.0126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB50A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DD9110"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123422869104479054930000005616216476619262395_)"
    },
    d: "M26.8,37.6c-3.7,0-6.9-1-9.2-2.9 c-2.4-2-3.6-4.9-3.6-8.4c0-3.3,1.2-6.3,3.3-8.4c2.2-2.2,5.3-3.3,8.9-3.3c3.7,0,5.5,0.7,6.7,1.3c1.4,0.8,2,2.3,1.6,4.1 c-0.1,0.7-0.3,1.5-0.5,2.1c-0.1,0.5-0.5,0.8-1,0.8h-0.1c-0.5,0-0.9-0.4-1-0.9c-0.5-3-2.5-4.5-5.8-4.5c-1.8,0-3.4,0.6-4.5,1.7 c-1.4,1.5-2.1,3.8-2.1,6.8c0.1,3,0.8,5.2,2.2,6.7c1.2,1.3,3,2,5.1,2c2.9,0,4.9-1.6,5.3-4.3c0.1-0.5,0.5-0.9,1-0.9h0.1 c0.5,0,1,0.4,1,0.9c0.3,2.7,0.2,5.3-2.1,6.3C31.4,37.2,30,37.6,26.8,37.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    width: 50,
    height: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIconCashCredit);
export default __webpack_public_path__ + "static/media/rewards_icon_cash_credit.f179b9d1cbe0d3ea298ea04399a94b05.svg";
export { ForwardRef as ReactComponent };